import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { IPackageTypes } from "../packagetypeModel";

export const getAllPackageTypes = createAsyncThunk(
  "PackageType/FindAllPackageType",
  async () => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/PackageType/FindAllPackageType`,
        {
          package_type: "",
        }
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Service:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getAllActivePackageTypes = createAsyncThunk(
  "PackageType/FindAllActivePackageType",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/PackageType/FindAllActivePackageType`
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching PackageTypes:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const createPackageTypes = createAsyncThunk(
  "PackageType/InsertPackageType",
  async (PackageTypesData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/PackageType/InsertPackageType`,
        PackageTypesData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating PackageTypes:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const updatePackageTypes = createAsyncThunk(
  "PackageType/UpdatePackageType",
  async (PackageTypesData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/PackageType/UpdatePackageType`,
        PackageTypesData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating PackageTypes:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getPackageTypesByID = createAsyncThunk(
  "PackageType/FindByIDPackageType",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/PackageType/FindByIDPackageType`,
        { package_type_guid: ID }
      );
      const result = response.data?.Data as any;
      return {
        package_type: result.package_type,
        package_type_guid: result.package_type_guid,
        isactive: result.isactive === true ? 1 : 2,
      } as IPackageTypes;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching PackageTypes:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const PackageTypesActiveInactive = createAsyncThunk(
  "PackageType/ActiveInActivePackageType",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/PackageType/ActiveInActivePackageType`,
        formData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error active-inactive PackageTypes:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const deletePackageTypes = createAsyncThunk(
  "PackageType/DeletePackageType",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/PackageType/DeletePackageType`,
        { package_type_guid: ID }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting typeofservice:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
